
import React, { useEffect, useState } from "react";
import { addDataTypeMapping, getAllDataTypes, getMappingAddedStatus, loadAllDataTypeMappings, loadAllDataTypes } from "../../store/dataTypes";
import { useDispatch, useSelector } from "react-redux";
import { getFieldData } from "../../../services/appService";
import { getCurrentUser } from "../../store/auth";
import { getAlert } from "../../../services/appAlerts";

const AddDataTypeMapping = (props) => {
    const { app, applicantObj, handleAddNewMapping, editingProfile, clearEditingProfile } = props;

    const [allMapObjects, setAllMapObjects] = useState([]);
    const [showHideNewItem, setShowHideNewItem] = useState(false);
    const [allDataTypes, setAllDataTypes] = useState([]);
    const [attributeList, setAttributeList] = useState([]);
    const [selectedDataType, setSelectedDataType] = useState("");
    const [selectedAttribute, setSelectedAttribute] = useState("");
    const [selectedAttributeValue, setSelectedAttributeValue] = useState("");
    const [selectedCommaSeprated, setSelectedCommaSeprated] = useState(false);
    const [mapObjectDataTypes, setMapObjectDateTypes] = useState([]);
    const [fieldName, setFieldName] = useState("")
    const [fieldMapWith, setFieldMapWith] = useState("dataType");
    const [mappingName, setMappingName] = useState("");
    const [mappingNotes, setMappingNotes] = useState("");
    const [activePopoverField, setActivePopoverField] = useState(null);

    const togglePopover = (fieldName) => {
        if (activePopoverField === fieldName) {
            setActivePopoverField(null);
        } else {
            setActivePopoverField(fieldName);
        }
    };

    const allDataTypesSelector = useSelector(getAllDataTypes);
    const mappingAddedStatusSelector = useSelector(getMappingAddedStatus);

    const dispatch = useDispatch();
    const currentUser = getCurrentUser();

    useEffect(() => {
        dispatch(loadAllDataTypes());
    }, [])

    useEffect(() => {
        setAllDataTypes(allDataTypesSelector);
    }, [allDataTypesSelector])

    const enrichMappingObjects = (parsedObjects) => {
        if (!parsedObjects || !Array.isArray(parsedObjects)) return [];
        return parsedObjects.map(item => {
            const enrichedReplaceDataTypes = item.replaceDataTypes.map(d => {
                let val = "";
                if (d.attObj === "id" && applicantObj) {
                    val = applicantObj.partnerType ? applicantObj.fuid : applicantObj.id;
                } else if (d.attType === "currentDate" && d.attObj === "date") {
                    val = new Date().toDateString();
                } else if (app?.applicationData) {
                    val = getFieldData(app.applicationData, d.attType.toLowerCase(), d.attObj);
                }
                return { ...d, attValue: val || "" };
            });
            return { ...item, replaceDataTypes: enrichedReplaceDataTypes };
        });
    };

    useEffect(() => {
        if (editingProfile) {
            setMappingName(editingProfile.name || "");
            setMappingNotes(editingProfile.notes || "");
            try {
                const parsed = JSON.parse(editingProfile.mappingJson);
                const enriched = enrichMappingObjects(Array.isArray(parsed) ? parsed : []);
                setAllMapObjects(enriched);
            } catch (e) {
                console.error("Error parsing mappingJson", e);
                setAllMapObjects([]);
            }
        } else {
            setMappingName("");
            setMappingNotes("");
            setAllMapObjects([]);
        }
    }, [editingProfile, allDataTypes, app, applicantObj]);

    const handleAddNewField = () => {
        setShowHideNewItem(true);
    }

    const handeSaveNewItem = () => {
        const isDuplicate = allMapObjects.some(x => x.field.trim().toLowerCase() === fieldName.trim().toLowerCase());
        if (isDuplicate) {
            getAlert("Duplicate Field", "A mapping for this field name already exists.", "error");
            return;
        }
        const mapObjects = [...allMapObjects];
        let mapDDObj = [...mapObjectDataTypes];
        if (fieldMapWith === "id" && applicantObj) {
            let att = "";
            let vl = "";
            if (applicantObj.partnerType) {
                att = applicantObj.partnerType;
                vl = applicantObj.fuid;
            }
            else {
                att = applicantObj.registrationType;
                vl = applicantObj.id;
            }

            const newObj = {
                attType: att,
                attObj: "id",
                attValue: vl
            }

            mapDDObj = [newObj];
        }

        if (fieldMapWith === "date") {
            const newObj = {
                attType: "currentDate",
                attObj: "date",
                attValue: new Date().toDateString()
            }

            mapDDObj = [newObj];
        }
        const mapObj = {
            field: fieldName,
            replaceDataTypes: mapDDObj,
            replaceValue: ""
        }
        mapObjects.push(mapObj);
        setAllMapObjects(mapObjects);
        setShowHideNewItem(false);
        setMapObjectDateTypes([]);
        setFieldName("");
        setSelectedAttribute("");
        setSelectedAttributeValue("");
        setSelectedDataType("");
        setFieldMapWith("dataType");
        setSelectedCommaSeprated(false);
    }

    const handleDataTypeChange = ({ target }) => {
        const findDD = allDataTypes.filter(x => x.id === parseInt(target.value));
        if (findDD.length > 0) {
            const jsData = JSON.parse(findDD[0].xsd);
            if (jsData) {
                let attList = [];
                jsData.map(d => {
                    const dd = d.split(".");
                    attList.push({ id: dd[0], name: dd[1] })
                })
                setAttributeList(attList);
            }
            setSelectedDataType(target.value);
        }
    }

    const handleAtributeChange = ({ target }) => {
        const findDD = allDataTypes.filter(x => x.id === parseInt(selectedDataType));
        if (findDD.length > 0 && app?.applicationData) {
            const attValue = getFieldData(app.applicationData, findDD[0].name.toLowerCase(), target.value);
            setSelectedAttributeValue(attValue);
        }
        setSelectedAttribute(target.value);
    }

    const handleSaveDataTypes = () => {
        const findDD = allDataTypes.filter(x => x.id === parseInt(selectedDataType));
        const mapDds = [...mapObjectDataTypes];
        const newObj = {
            attType: findDD[0].name,
            attObj: selectedAttribute,
            attValue: selectedAttributeValue,
            attCommaSeperated: selectedCommaSeprated
        }
        mapDds.push(newObj);
        setMapObjectDateTypes(mapDds);
        setSelectedDataType("");
        setSelectedAttribute("");
        setSelectedAttributeValue("");
        setSelectedCommaSeprated(false);
    }

    const handleDeleteMapObject = (item) => {
        const index = mapObjectDataTypes.findIndex(x => x.attType === item.attType && x.attObj === item.attObj);
        const mapDds = [...mapObjectDataTypes];
        mapDds.splice(index, 1);
        setMapObjectDateTypes(mapDds);
    }

    const handleClose = () => {
        setAllMapObjects([]);
        if (clearEditingProfile) clearEditingProfile();
        handleAddNewMapping();
    }

    const handleMapWithChange = ({ currentTarget: input }) => {
        setFieldMapWith(input.value);
    }

    const handleSaveMapping = () => {
        let perfId = 0;
        let perfType = "";
        if (applicantObj.partnerType) {
            perfType = applicantObj.partnerType;
            perfId = applicantObj.fuid;
        }
        else {
            perfType = applicantObj.registrationType;
            perfId = applicantObj.id;
        }
        const modifiedMappingData = allMapObjects.map(x => {
            x.replaceDataTypes.map(d => {
                d.attValue = "";
                return d;
            })
            return x;
        })
        const obj = {
            id: editingProfile ? editingProfile.id : 0,
            name: mappingName,
            type: perfType,
            notes: mappingNotes,
            mappingJson: JSON.stringify(modifiedMappingData),
            addedBy: currentUser.id,
            performerId: perfId,
            performerType: perfType
        }
        dispatch(addDataTypeMapping(obj))
    }

    useEffect(() => {
        if (mappingAddedStatusSelector) {
            getAlert("", editingProfile ? "Updated Successfully" : "Added Successfully", "success");
            dispatch(loadAllDataTypeMappings());
            setAllMapObjects([]);
            if (clearEditingProfile) clearEditingProfile();
            handleAddNewMapping();
        }
    }, [mappingAddedStatusSelector]);

    const handleCloseNewItem = () => {
        setMapObjectDateTypes([]);
        setFieldName("");
        setFieldMapWith("dataType");
        setShowHideNewItem(false);
    }

    const handleDeleteMappItem = (e, item) => {
        if (e) {
            e.stopPropagation();
            e.preventDefault();
        }
        const ddMapps = [...allMapObjects];
        const index = allMapObjects.findIndex(x => x.field === item.field);
        if (index > -1) {
            ddMapps.splice(index, 1);
            setAllMapObjects(ddMapps);
            if (activePopoverField === item.field) {
                setActivePopoverField(null);
            }
        }
    }

    const getLivePreview = () => {
        if (fieldMapWith === "id") {
            return applicantObj.partnerType ? applicantObj.fuid : applicantObj.id;
        }
        if (fieldMapWith === "date") {
            return new Date().toDateString();
        }
        if (fieldMapWith === "dataType") {
            if (!mapObjectDataTypes || mapObjectDataTypes.length === 0) {
                return selectedAttributeValue || "";
            }
            let compiled = "";
            mapObjectDataTypes.forEach((v, idx) => {
                const val = v.attValue || "";
                if (val) {
                    compiled += val + (v.attCommaSeperated ? ", " : (idx < mapObjectDataTypes.length - 1 ? " " : ""));
                }
            });
            return compiled.trim();
        }
        return "";
    }

    const getCompiledValue = (item) => {
        if (!item || !item.replaceDataTypes) return "";
        let compiled = "";
        item.replaceDataTypes.filter(x => x.attValue !== "" && x.attValue !== undefined && x.attValue !== null).forEach((v, idx, arr) => {
            compiled += v.attValue + (v.attCommaSeperated ? ", " : (idx < arr.length - 1 ? " " : ""));
        });
        return compiled.trim();
    }

    return <>
        <style>{`
            .adm-container,
            .adm-container button,
            .adm-container input,
            .adm-container select,
            .adm-container textarea {
                font-family: "Open Sans", sans-serif !important;
            }
            .adm-container {
                display: flex;
                flex-direction: column;
                gap: 20px;
                animation: admFadeIn 0.3s ease both;
            }
            .adm-live-preview-container {
                margin-top: 8px;
                background: #f8fafc;
                border: 1px solid #cbd5e1;
                border-left: 3px solid #2563eb;
                padding: 12px 14px;
                display: flex;
                flex-direction: column;
                gap: 8px;
                animation: admFadeIn 0.2s ease both;
            }
            .adm-live-preview-header {
                display: flex;
                align-items: center;
                justify-content: space-between;
            }
            .adm-live-preview-title {
                font-size: 11px;
                font-weight: 700;
                color: #2563eb;
                text-transform: uppercase;
                letter-spacing: 0.05em;
                display: inline-flex;
                align-items: center;
                gap: 5px;
            }
            .adm-live-preview-count {
                font-size: 11px;
                color: #64748b;
                background: #e2e8f0;
                padding: 2px 7px;
                font-weight: 500;
            }
            .adm-live-preview-content {
                display: flex;
                flex-direction: column;
                gap: 6px;
            }
            .adm-live-preview-result {
                font-size: 14px;
                font-weight: 600;
                color: #0f172a;
                background: #ffffff;
                border: 1px solid #e2e8f0;
                padding: 8px 12px;
                word-break: break-word;
            }
            .adm-live-preview-breakdown {
                display: flex;
                flex-wrap: wrap;
                gap: 6px;
                align-items: center;
            }
            .adm-live-preview-chip {
                display: inline-flex;
                align-items: center;
                gap: 4px;
                background: #ffffff;
                border: 1px solid #e2e8f0;
                padding: 2px 8px;
                font-size: 11.5px;
            }
            .adm-chip-key {
                color: #64748b;
            }
            .adm-chip-val {
                color: #0f172a;
                font-weight: 600;
            }
            .adm-chip-sep {
                color: #2563eb;
                font-weight: 700;
            }
            @keyframes admFadeIn {
                from { opacity: 0; transform: translateY(8px); }
                to { opacity: 1; transform: translateY(0); }
            }
            .adm-card {
                display: flex;
                flex-direction: column;
                gap: 20px;
            }
            .adm-card.highlight {
                background: #ffffff;
                border: 1px solid #cbd5e1;
                border-radius: 0 !important;
                padding: 24px;
                display: flex;
                flex-direction: column;
                gap: 20px;
                box-shadow: none !important;
            }
            .adm-two-col {
                display: flex;
                gap: 20px;
                align-items: stretch;
                width: 100%;
            }
            .adm-dashboard-card {
                background: #ffffff;
                border: 1px solid #cbd5e1;
                border-radius: 0 !important;
                box-shadow: none !important;
                padding: 20px;
            }
            .adm-main-panel {
                flex: 1;
                min-width: 0;
                display: flex;
                flex-direction: column;
                gap: 16px;
            }
            .adm-main-panel .adm-table-container {
                border: none;
                box-shadow: none;
                background: transparent;
                border-radius: 0;
            }
            .adm-side-panel {
                width: 380px;
                flex-shrink: 0;
                display: flex;
                flex-direction: column;
                gap: 20px;
                position: sticky;
                top: 20px;
            }
            @media (max-width: 992px) {
                .adm-two-col {
                    flex-direction: column;
                }
                .adm-side-panel {
                    width: 100%;
                    position: static;
                }
            }
            .adm-form-group {
                display: flex;
                flex-direction: column;
                gap: 8px;
            }
            .adm-label {
                font-size: 11.5px;
                font-weight: 600;
                color: #475569;
                text-transform: uppercase;
                letter-spacing: 0.04em;
                text-align: left;
            }
            .adm-choice-cards {
                display: grid;
                grid-template-columns: repeat(3, 1fr);
                gap: 12px;
                margin-top: 4px;
            }
            @media (max-width: 640px) {
                .adm-choice-cards {
                    grid-template-columns: 1fr;
                }
            }
            .adm-choice-card {
                border: 1px solid #cbd5e1;
                border-radius: 0 !important;
                background: #ffffff;
                padding: 14px;
                cursor: pointer;
                transition: all 0.15s ease;
                display: flex;
                gap: 12px;
                align-items: flex-start;
                text-align: left;
                position: relative;
            }
            .adm-choice-card:hover {
                border-color: #94a3b8;
                transform: translateY(-1px);
            }
            .adm-choice-card.active {
                border-color: #171717;
                background: #fafafa;
            }
            .adm-choice-icon {
                width: 32px;
                height: 32px;
                border-radius: 0 !important;
                background: #f1f5f9;
                color: #64748b;
                border: 1px solid #cbd5e1;
                display: inline-flex;
                align-items: center;
                justify-content: center;
                font-size: 15px;
                flex-shrink: 0;
                transition: all 0.15s ease;
            }
            .adm-choice-card.active .adm-choice-icon {
                background: #171717;
                color: #ffffff;
                border-color: #171717;
            }
            .adm-choice-content {
                display: flex;
                flex-direction: column;
                gap: 2px;
                min-width: 0;
            }
            .adm-choice-title {
                font-size: 13px;
                font-weight: 600;
                color: #0f172a;
            }
            .adm-choice-desc {
                font-size: 11px;
                color: #64748b;
                line-height: 1.3;
            }
            .adm-input, .adm-textarea, .adm-select {
                width: 100%;
                min-height: 40px;
                padding: 10px 14px;
                border-radius: 0 !important;
                border: 1px solid #cbd5e1;
                background-color: #ffffff;
                color: #1e293b;
                font-size: 13.5px;
                font-weight: 400;
                transition: all 0.15s ease;
                outline: none;
                text-align: left;
            }
            .adm-input:focus, .adm-textarea:focus, .adm-select:focus {
                border-color: #2563eb;
                box-shadow: 0 0 0 3px rgba(37, 99, 235, 0.15);
            }
            .adm-textarea {
                resize: vertical;
            }
            .adm-select {
                cursor: pointer;
            }
            .adm-btn-row {
                display: flex;
                align-items: center;
                justify-content: flex-end;
                gap: 10px;
                margin-top: 10px;
            }
            .adm-btn {
                min-height: 36px;
                display: inline-flex;
                align-items: center;
                justify-content: center;
                gap: 6px;
                padding: 7px 16px;
                border-radius: 0 !important;
                font-size: 13px;
                font-weight: 500;
                cursor: pointer;
                transition: all 0.15s ease;
                white-space: nowrap;
                border: 1px solid #cbd5e1;
                background: #ffffff;
                color: #1e293b;
                box-shadow: 0 2px 5px rgba(15, 23, 42, 0.08);
            }
            .adm-btn:hover:not(:disabled) {
                background: #f8fafc;
                border-color: #94a3b8;
                transform: translateY(-1px);
            }
            .adm-btn:disabled {
                opacity: 0.6;
                cursor: not-allowed;
            }
            .adm-btn.primary {
                background: #2563eb;
                border-color: #2563eb;
                color: #ffffff;
                box-shadow: 0 2px 5px rgba(37, 99, 235, 0.2);
            }
            .adm-btn.primary:hover:not(:disabled) {
                background: #1d4ed8;
                border-color: #1d4ed8;
                color: #ffffff;
            }
            .adm-btn.secondary {
                background: #ffffff;
                border-color: #cbd5e1;
                color: #1e293b;
            }
            .adm-btn.secondary:hover:not(:disabled) {
                background: #f8fafc;
                border-color: #94a3b8;
            }
            .adm-btn.danger {
                background: #ffffff;
                border-color: #cbd5e1;
                color: #ef4444;
            }
            .adm-btn.danger:hover:not(:disabled) {
                background: #fef2f2;
                border-color: #ef4444;
            }
            .adm-table-container {
                width: 100%;
                border: 1px solid #cbd5e1;
                border-radius: 0 !important;
                overflow: hidden;
                background: #ffffff;
            }
            .adm-table {
                width: 100%;
                border-collapse: collapse;
                text-align: left;
                font-size: 13px;
            }
            .adm-table thead {
                background: #f8fafc !important;
                position: sticky !important;
                top: 0 !important;
                z-index: 2 !important;
            }
            .adm-table th {
                font-size: 12px !important;
                font-weight: 600 !important;
                color: #64748b !important;
                text-transform: uppercase !important;
                letter-spacing: 0.6px !important;
                padding: 13px 16px !important;
                border-bottom: 2px solid #e2e8f0 !important;
                border-top: none !important;
                border-left: none !important;
                border-right: none !important;
                white-space: nowrap !important;
            }
            .adm-table td {
                padding: 12px 16px;
                vertical-align: middle;
                border-bottom: 1px solid #f1f5f9;
                color: #1e293b;
            }
            .adm-table tbody tr:last-child td {
                border-bottom: none;
            }
            .adm-field-code {
                font-family: Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace;
                font-size: 12px;
                font-weight: 700;
                color: #0f172a;
                background: #f1f5f9;
                padding: 4px 8px;
                border-radius: 0 !important;
                border: 1px solid #cbd5e1;
                display: inline-block;
            }
            .adm-datatype-stack, .adm-value-stack {
                display: flex;
                flex-direction: column;
                gap: 6px;
            }
            .adm-datatype-badge {
                display: inline-flex;
                align-items: center;
                gap: 6px;
                padding: 4px 10px;
                background: #ffffff;
                color: #1e293b;
                font-size: 12.5px;
                font-weight: 500;
                border-radius: 0 !important;
                border: 1px solid #cbd5e1;
                line-height: 1.2;
                align-self: flex-start;
            }
            .adm-attr-text {
                font-size: 13px;
                font-weight: 500;
                color: #1e293b;
            }
            .adm-value-badge {
                display: inline-flex;
                align-items: center;
                padding: 4px 10px;
                background: #f0f9ff;
                color: #0369a1;
                font-size: 12.5px;
                font-weight: 500;
                border-radius: 0 !important;
                border: 1px solid #e0f2fe;
                line-height: 1.2;
                align-self: flex-start;
            }
            .adm-value-empty {
                font-size: 12.5px;
                color: #94a3b8;
                font-style: italic;
            }
            .adm-delete-btn {
                background: #ffffff;
                border: 1px solid #cbd5e1;
                color: #ef4444;
                font-size: 12px;
                font-weight: 500;
                cursor: pointer;
                padding: 0;
                width: 32px;
                min-width: 32px;
                height: 32px;
                min-height: 32px;
                border-radius: 0 !important;
                transition: all 0.15s ease;
                display: inline-flex;
                align-items: center;
                justify-content: center;
                box-sizing: border-box;
            }
            .adm-delete-btn:hover {
                background: #fef2f2;
                color: #dc2626;
                border-color: #ef4444;
                transform: translateY(-1px);
            }
            .adm-field-list {
                display: flex;
                flex-direction: column;
                gap: 0;
                width: 100%;
            }
            .adm-field-card {
                border: 0;
                border-bottom: 1px solid #e2e8f0;
                border-radius: 0 !important;
                background: #ffffff;
                padding: 16px;
                display: flex;
                flex-direction: column;
                gap: 12px;
                transition: all 0.15s ease;
                position: relative;
                overflow: hidden;
            }
            .adm-field-card:hover {
                background: #f8fafc;
                border-bottom-color: #cbd5e1;
            }
            .adm-field-card-header {
                display: flex;
                justify-content: space-between;
                align-items: center;
                padding-bottom: 0;
                border-bottom: none;
            }
            .adm-field-card.expanded .adm-field-card-header {
                border-bottom: 1px dashed #f1f5f9;
                padding-bottom: 10px;
            }
            .adm-field-card-body {
                display: grid;
                grid-template-columns: 1.2fr 1fr;
                gap: 20px;
            }
            @media (max-width: 640px) {
                .adm-field-card-body {
                    grid-template-columns: 1fr;
                    gap: 12px;
                }
            }
            .adm-meta-item {
                display: flex;
                flex-direction: column;
                gap: 6px;
                text-align: left;
            }
            .adm-meta-label {
                font-size: 11px;
                font-weight: 800;
                color: #64748b;
                text-transform: uppercase;
                letter-spacing: 0.05em;
            }
            .adm-empty-state {
                display: flex;
                flex-direction: column;
                align-items: center;
                justify-content: center;
                padding: 48px 24px;
                text-align: center;
                border: 1px dashed #cbd5e1;
                border-radius: 0 !important;
                background: #f8fafc;
            }
            .adm-empty-icon {
                font-size: 28px;
                color: #cbd5e1;
                margin-bottom: 8px;
            }
            .adm-empty-title {
                font-size: 14px;
                font-weight: 600;
                color: #0f172a;
                margin-bottom: 4px;
            }
            .adm-empty-desc {
                font-size: 12.5px;
                color: #64748b;
                margin: 0;
                max-width: 280px;
                line-height: 1.4;
            }
        `}</style>

        {showHideNewItem && (
            <div className="adm-container">
                <div className="adm-card highlight">
                    <div style={{ borderBottom: "1px solid #e2e8f0", paddingBottom: "12px", marginBottom: "4px" }}>
                        <h4 style={{ margin: 0, fontWeight: 600, color: "#334155", fontSize: "12.5px", textTransform: "uppercase", letterSpacing: "0.04em", textAlign: "left" }}>Add New Field Mapping</h4>
                    </div>

                    <div className="adm-form-group">
                        <label htmlFor="txtField" className="adm-label">Field Name</label>
                        <input
                            id="txtField"
                            name="txtField"
                            type="text"
                            className="adm-input"
                            style={fieldName && allMapObjects.some(x => x.field.trim().toLowerCase() === fieldName.trim().toLowerCase()) ? { borderColor: "#ef4444", boxShadow: "0 0 0 3px rgba(239, 68, 68, 0.15)" } : {}}
                            placeholder="e.g. #CANDIDATE_NAME#"
                            value={fieldName}
                            onChange={({ currentTarget }) => setFieldName(currentTarget.value)}
                        />
                        {fieldName && allMapObjects.some(x => x.field.trim().toLowerCase() === fieldName.trim().toLowerCase()) && (
                            <span style={{ color: "#ef4444", fontSize: "12px", fontWeight: "600", textAlign: "left", marginTop: "2px" }}>
                                <i className="fa fa-exclamation-circle" /> A mapping for this field name already exists.
                            </span>
                        )}

                        {getLivePreview() && (
                            <div className="adm-live-preview-container">
                                <div className="adm-live-preview-header">
                                    <span className="adm-live-preview-title">
                                        <i className="fa fa-eye" /> Live Value Preview
                                    </span>
                                    {mapObjectDataTypes.length > 1 && (
                                        <span className="adm-live-preview-count">
                                            {mapObjectDataTypes.length} attributes combined
                                        </span>
                                    )}
                                </div>
                                <div className="adm-live-preview-content">
                                    <div className="adm-live-preview-result">
                                        {getLivePreview()}
                                    </div>
                                </div>
                            </div>
                        )}
                    </div>

                    <div className="adm-form-group">
                        <label className="adm-label">Map With</label>
                        <div className="adm-choice-cards">
                            <div
                                className={`adm-choice-card ${fieldMapWith === "id" ? "active" : ""}`}
                                onClick={() => setFieldMapWith("id")}
                            >
                                <div className="adm-choice-icon">
                                    <i className="fa fa-id-card-o" />
                                </div>
                                <div className="adm-choice-content">
                                    <span className="adm-choice-title">Entity ID</span>
                                    <span className="adm-choice-desc">Map applicant's registration/FUID database key</span>
                                </div>
                            </div>
                            <div
                                className={`adm-choice-card ${fieldMapWith === "date" ? "active" : ""}`}
                                onClick={() => setFieldMapWith("date")}
                            >
                                <div className="adm-choice-icon">
                                    <i className="fa fa-calendar" />
                                </div>
                                <div className="adm-choice-content">
                                    <span className="adm-choice-title">Current Date</span>
                                    <span className="adm-choice-desc">Automatically populate the generation timestamp</span>
                                </div>
                            </div>
                            <div
                                className={`adm-choice-card ${fieldMapWith === "dataType" ? "active" : ""}`}
                                onClick={() => setFieldMapWith("dataType")}
                            >
                                <div className="adm-choice-icon">
                                    <i className="fa fa-database" />
                                </div>
                                <div className="adm-choice-content">
                                    <span className="adm-choice-title">Redux DataType</span>
                                    <span className="adm-choice-desc">Map to custom application properties</span>
                                </div>
                            </div>
                        </div>
                    </div>

                    {fieldMapWith === "dataType" && (
                        <div className="adm-form-group">
                            <label className="adm-label">DataType Mappings</label>
                            <div className="adm-table-container">
                                <table className="adm-table">
                                    <thead>
                                        <tr>
                                            <th style={{ width: "28%" }}>DataType</th>
                                            <th style={{ width: "28%" }}>Attribute</th>
                                            <th style={{ width: "24%" }}>Value Preview</th>
                                            <th style={{ width: "12%", textAlign: "center", whiteSpace: "nowrap" }}>Comma Sep.</th>
                                            <th style={{ width: "8%", textAlign: "center", whiteSpace: "nowrap" }}>Action</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {mapObjectDataTypes.map((item, idx) => (
                                            <tr key={idx}>
                                                <td>
                                                    <span className="adm-datatype-badge">
                                                        {item.attType}
                                                    </span>
                                                </td>
                                                <td><span className="adm-attr-text">{item.attObj}</span></td>
                                                <td>
                                                    {item.attValue ? (
                                                        <span className="adm-value-badge">{item.attValue}</span>
                                                    ) : (
                                                        <span className="adm-value-empty">—</span>
                                                    )}
                                                </td>
                                                <td style={{ textAlign: "center" }}>{item.attCommaSeperated ? "Yes" : "No"}</td>
                                                <td style={{ textAlign: "center" }}>
                                                    <button
                                                        type="button"
                                                        className="adm-delete-btn"
                                                        onClick={() => handleDeleteMapObject(item)}
                                                        title="Delete"
                                                    >
                                                        <i className="fa fa-trash-o" />
                                                    </button>
                                                </td>
                                            </tr>
                                        ))}
                                        <tr>
                                            <td>
                                                <select
                                                    name="ddType"
                                                    id="ddType"
                                                    className="adm-select"
                                                    style={{ minHeight: "34px", height: "34px", padding: "4px 8px", fontSize: "13px" }}
                                                    onChange={handleDataTypeChange}
                                                    value={selectedDataType}
                                                >
                                                    <option value="">Select DataType...</option>
                                                    {allDataTypes.map(x =>
                                                        <option key={x.id} value={x.id}>{x.dataLabel}</option>
                                                    )}
                                                </select>
                                            </td>
                                            <td>
                                                <select
                                                    name="ddAtt"
                                                    id="ddAtt"
                                                    className="adm-select"
                                                    style={{ minHeight: "34px", height: "34px", padding: "4px 8px", fontSize: "13px" }}
                                                    onChange={handleAtributeChange}
                                                    value={selectedAttribute}
                                                    disabled={!selectedDataType}
                                                >
                                                    <option value="">Select Attribute...</option>
                                                    {attributeList.map(x =>
                                                        <option key={x.id} value={x.id}>{x.name}</option>
                                                    )}
                                                </select>
                                            </td>
                                            <td>
                                                {selectedAttributeValue ? (
                                                    <span className="adm-value-badge">{selectedAttributeValue}</span>
                                                ) : (
                                                    <span className="adm-value-empty">No value</span>
                                                )}
                                            </td>
                                            <td style={{ textAlign: "center" }}>
                                                <input
                                                    type="checkbox"
                                                    id={`chk${selectedDataType}`}
                                                    name={`chk${selectedDataType}`}
                                                    style={{ width: "16px", height: "16px", cursor: "pointer", accentColor: "#2563eb" }}
                                                    onChange={({ target }) => setSelectedCommaSeprated(target.checked)}
                                                    checked={selectedCommaSeprated}
                                                    disabled={!selectedAttribute}
                                                />
                                            </td>
                                            <td style={{ textAlign: "center" }}>
                                                <button
                                                    type="button"
                                                    className="adm-btn primary"
                                                    style={{ minHeight: "34px", height: "34px", padding: "0 14px", fontSize: "12.5px" }}
                                                    onClick={handleSaveDataTypes}
                                                    disabled={!selectedAttribute}
                                                >
                                                    <i className="fa fa-plus" /> Add
                                                </button>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    )}

                    <div className="adm-btn-row" style={{ borderTop: "1px solid #e2e8f0", paddingTop: "16px", marginTop: "10px" }}>
                        <button type="button" className="adm-btn" onClick={handleCloseNewItem}>
                            <i className="fa fa-times" /> Cancel
                        </button>
                        <button type="button" className="adm-btn primary" onClick={handeSaveNewItem} disabled={!fieldName || allMapObjects.some(x => x.field.trim().toLowerCase() === fieldName.trim().toLowerCase())}>
                            <i className="fa fa-check" /> Add Field
                        </button>
                    </div>
                </div>
            </div>
        )}

        {!showHideNewItem && (
            <div className="adm-container">
                <div className="adm-card">
                    <div className="adm-two-col">
                        <div className="adm-main-panel adm-dashboard-card">
                            <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", borderBottom: "1px solid #f1f5f9", paddingBottom: "12px", marginBottom: "4px" }}>
                                <h4 style={{ margin: 0, fontWeight: 600, color: "#334155", fontSize: "12.5px", textTransform: "uppercase", letterSpacing: "0.04em", textAlign: "left" }}>
                                    {editingProfile ? "Edit Configured Fields" : "Configured Fields"}
                                </h4>
                                <button type="button" className="adm-btn secondary" onClick={handleAddNewField}>
                                    <i className="fa fa-plus" /> Add New Field
                                </button>
                            </div>

                            {allMapObjects.length === 0 ? (
                                <div className="adm-empty-state" style={{ marginTop: "12px" }}>
                                    <div className="adm-empty-icon"><i className="fa fa-sliders" /></div>
                                    <div className="adm-empty-title">No mapped fields yet</div>
                                    <p className="adm-empty-desc">Click "Add New Field" above to start mapping fields.</p>
                                </div>
                            ) : (
                                <div className="adm-field-list" style={{ marginTop: "12px" }}>
                                    {allMapObjects.map((item) => (
                                        <div key={item.field} className={`adm-field-card ${activePopoverField === item.field ? "expanded" : ""}`}>
                                            <div className="adm-field-card-header">
                                                <div style={{ display: "flex", alignItems: "center", gap: "10px", flexWrap: "wrap" }}>
                                                    <span className="adm-field-code">{item.field}</span>
                                                    <div style={{ display: "inline-flex", alignItems: "center", gap: "6px" }}>
                                                        <span style={{ fontSize: "11.5px", color: "#64748b", fontWeight: "600", textTransform: "uppercase" }}>Value:</span>
                                                        <span style={{ fontSize: "13px", color: "#0f172a", fontWeight: "600", background: "#f8fafc", padding: "3px 8px", border: "1px solid #e2e8f0" }}>
                                                            {getCompiledValue(item) || <span className="adm-value-empty">No value mapped</span>}
                                                        </span>
                                                    </div>
                                                </div>
                                                <div style={{ display: "flex", gap: "8px", alignItems: "center" }}>
                                                    <button
                                                        type="button"
                                                        className={`adm-btn ${activePopoverField === item.field ? "primary" : ""}`}
                                                        style={{ minHeight: "32px", height: "32px", padding: "0 12px", fontSize: "13px", boxSizing: "border-box", display: "inline-flex", alignItems: "center", gap: "6px" }}
                                                        onClick={(e) => { e.stopPropagation(); togglePopover(item.field); }}
                                                    >
                                                        <i className="fa fa-database" /> Datatype
                                                    </button>
                                                    <button
                                                        type="button"
                                                        className="adm-delete-btn"
                                                        style={{ minHeight: "32px", height: "32px", width: "32px", padding: "0", display: "inline-flex", alignItems: "center", justifyContent: "center", boxSizing: "border-box" }}
                                                        onClick={(e) => handleDeleteMappItem(e, item)}
                                                        title="Delete"
                                                    >
                                                        <i className="fa fa-trash-o" />
                                                    </button>
                                                </div>
                                            </div>
                                            {activePopoverField === item.field && (
                                                <div className="adm-field-card-body">
                                                    <div className="adm-meta-item">
                                                        <span className="adm-meta-label">Mapped Attributes</span>
                                                        <div className="adm-datatype-stack">
                                                            {item.replaceDataTypes.map((m, idx) => (
                                                                <div key={idx} className="adm-datatype-badge">
                                                                    <span>{m.attType}.{m.attObj}</span>
                                                                </div>
                                                            ))}
                                                        </div>
                                                    </div>
                                                    <div className="adm-meta-item">
                                                        <span className="adm-meta-label">Value Preview</span>
                                                        <div className="adm-value-stack">
                                                            {item.replaceDataTypes.map((m, idx) => (
                                                                <div key={idx} className="adm-value-item">
                                                                    {m.attValue ? (
                                                                        <span className="adm-value-badge">{m.attValue}</span>
                                                                    ) : (
                                                                        <span className="adm-value-empty">—</span>
                                                                    )}
                                                                </div>
                                                            ))}
                                                        </div>
                                                    </div>
                                                </div>
                                            )}
                                        </div>
                                    ))}
                                </div>
                            )}
                        </div>

                        <div className="adm-side-panel adm-dashboard-card">
                            <h4 style={{ margin: "0 0 4px 0", fontWeight: 600, color: "#334155", fontSize: "12.5px", textTransform: "uppercase", letterSpacing: "0.04em", textAlign: "left", borderBottom: "1px solid #e2e8f0", paddingBottom: "12px" }}>
                                {editingProfile ? "Edit Profile Configuration" : "Profile Configuration"}
                            </h4>

                            <div className="adm-form-group">
                                <label htmlFor="mapName" className="adm-label">Mapping Profile Name</label>
                                <input
                                    type="text"
                                    id="mapName"
                                    name="mapName"
                                    className="adm-input"
                                    placeholder="e.g. Candidate Declaration Mapping"
                                    value={mappingName}
                                    onChange={({ currentTarget }) => setMappingName(currentTarget.value)}
                                />
                            </div>

                            <div className="adm-form-group">
                                <label htmlFor="mapNotes" className="adm-label">Notes / Description</label>
                                <textarea
                                    id="mapNotes"
                                    name="mapNotes"
                                    rows={4}
                                    className="adm-textarea"
                                    placeholder="Add profile details, guidelines, or logic context..."
                                    value={mappingNotes}
                                    onChange={({ currentTarget }) => setMappingNotes(currentTarget.value)}
                                />
                            </div>

                            <div className="adm-btn-row" style={{ borderTop: "1px solid #e2e8f0", paddingTop: "16px", marginTop: "auto", justifyContent: "space-between", width: "100%" }}>
                                <button type="button" className="adm-btn" onClick={handleClose}>
                                    <i className="fa fa-arrow-left" /> Cancel
                                </button>
                                <button
                                    type="button"
                                    className="adm-btn primary"
                                    onClick={handleSaveMapping}
                                    disabled={allMapObjects.length === 0 || !mappingName}
                                >
                                    <i className="fa fa-cloud-upload" /> {editingProfile ? "Update Profile" : "Save Profile"}
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )}
    </>
}

export default AddDataTypeMapping;